import React from 'react';
import Navigation from '../Components/Navigation';

const NavigationContainer = props => (
    <Navigation {...props} />
)

export default NavigationContainer;